import { API } from '@typedream/data';

export const api = API.getOrCreateInstance;
